import React from 'react';

const CustomDivider = ({
  width = '100%',
  height = '2px',
  backgroundColor = 'rgba(255, 233, 0, 1)', // Amarillo por defecto
  border = 'none',
  borderColor = 'transparent',
  margin = '20px 0', // Márgenes por defecto
  style = {}, // Permite agregar estilos adicionales
  className = ''
}) => {
  return (
    <div
      className={className}
      style={{
        width: width,
        height: height,
        backgroundColor: backgroundColor,
        border: border,
        borderColor: borderColor,
        margin: margin,
        ...style // Agrega cualquier estilo adicional pasado como prop
      }}
    />
  );
};

export default CustomDivider;
